import { Capacitor } from '@capacitor/core';

import mainCharPng from '/img/characters/contract-char-v4.png';
import mainCharWebp from '/img/characters/contract-char-v4.webp';
import lumberCharPng from '/img/characters/lumberjack-char-small.png';
import lumberCharWebp from '/img/characters/lumberjack-char-small.webp';
import materialsCharPng from '/img/characters/materials-main-char-v2.png';
import materialsCharWebp from '/img/characters/materials-main-char-v2.webp';

const isNativeApp = Capacitor.isNativePlatform();

interface IntroStepsConfigValue {
  title?: string;
  text: string;
  withNextButton?: boolean;
  withAdditionalButton?: boolean;
  selector?: string;
  isEnd?: boolean;
  margin?: number;
  withoutHand?: boolean;
  buttonText: string;
  character?: {
    png: string;
    webp: string;
    config?: {
      height?: string;
      width?: string;
      left?: string;
      bottom?: string;
    };
  };
  classNames?: {
    content?: string;
    animation?: string;
  };
  containerStyle?: {
    width?: string;
    left?: string;
    top?: string;
    bottom?: string;
    transform?: string;
  };
  defaultPosition?: {
    top?: string;
    bottom?: string;
  };
}

const newIntroSteps: Record<number, IntroStepsConfigValue> = {
  1: {
    title: '🎁 Your first bonus awaits!',
    text: 'Let me show you how to start playing! Yo’ll also receive a bonus in the form of T-Gem, an in-game currency, to get you started quickly.',
    buttonText: 'Start & Earn',
    withNextButton: true,
    withAdditionalButton: true,
    withoutHand: true,
    character: {
      png: mainCharPng,
      webp: mainCharWebp,
      config: {
        left: '0',
      },
    },
    containerStyle: {
      width: '70%',
      transform: 'translate(-55%, -10%)',
    },
    defaultPosition: { bottom: '1rem' },
  },
  2: {
    text: '',
    buttonText: '',
    selector: '#intro-step-2',
    margin: -24,
  },
  3: {
    text: '',
    buttonText: '',
    selector: '#intro-step-3',
  },
  // 4: {
  //   text: 'Hey, Boss! We’re working around the clock, but if you’ve got some energy, we can speed things up',
  //   buttonText: 'Speed up mining',
  //   character: {
  //     png: lumberCharPng,
  //     webp: lumberCharWebp,
  //     config: {
  //       left: '-20%',
  //     },
  //   },
  //   withNextButton: true,
  //   withoutHand: true,
  //   margin: -147,
  // },
  // 5: {
  //   text: '',
  //   buttonText: '',
  //   selector: '#intro-step-5',
  //   // margin: 97,
  // },
  6: {
    text: 'The internal storage has limited space. Don’t forget to send resources to the Stock',
    buttonText: 'Send to Stock',
    selector: '#intro-step-6',
    character: {
      png: lumberCharPng,
      webp: lumberCharWebp,
      config: {
        left: '-20%',
      },
    },
    withNextButton: true,
    withoutHand: true,
    margin: 48,
  },
  7: {
    text: '',
    buttonText: '',
    selector: '#intro-step-7',
    margin: -24,
  },
  8: {
    text: 'Nice! You can now gather wood. Might be a good idea to build a Sawmill',
    buttonText: 'Back to Office',
    character: {
      png: mainCharPng,
      webp: mainCharWebp,
      config: {
        left: '0',
      },
    },
    withNextButton: true,
    withoutHand: true,
    margin: -83,
  },
  9: {
    text: '',
    buttonText: '',
    selector: '#intro-step-9',
  },
  10: {
    text: '',
    buttonText: '',
    selector: '#intro-step-10',
  },
  11: {
    text: "We've got enough wood in storage. Let's produce some lumber",
    buttonText: 'Start production',
    character: {
      png: materialsCharPng,
      webp: materialsCharWebp,
      config: {
        left: '0',
      },
    },
    withNextButton: true,
    withoutHand: true,
    margin: 16,
  },
  12: {
    text: '',
    buttonText: '',
    selector: '#intro-step-12',
  },
  13: {
    text: 'Great! Time to boost production',
    buttonText: 'Forward',
    character: {
      png: materialsCharPng,
      webp: materialsCharWebp,
      config: {
        left: '0',
      },
    },
    withNextButton: true,
    withoutHand: true,
    margin: 66,
  },
  14: {
    text: '',
    buttonText: '',
    selector: '#intro-step-14',
    margin: -33,
  },
  15: {
    text: '',
    buttonText: '',
    selector: '#intro-step-15',
    // margin: -251,
  },
  16: {
    text: 'Production complete. Let’s send the lumber to Stock',
    buttonText: 'Send to Stock',
    character: {
      png: materialsCharPng,
      webp: materialsCharWebp,
      config: {
        left: '0',
      },
    },
    withNextButton: true,
    withoutHand: true,
  },
  17: {
    text: '',
    buttonText: '',
    selector: '#intro-step-17',
  },
  18: {
    text: 'Congrats! We can now build a Furniture Factory',
    buttonText: 'Build',
    character: {
      png: materialsCharPng,
      webp: materialsCharWebp,
      config: {
        left: '0',
      },
    },
    withNextButton: true,
    withoutHand: true,
  },
  19: {
    text: '',
    buttonText: '',
    selector: '#intro-step-19',
  },
  // 20: {
  //   text: '',
  //   buttonText: '',
  // },
  21: {
    text: '',
    buttonText: '',
    selector: '#intro-step-21',
  },
  22: {
    text: 'Great! Contracts are now available',
    buttonText: 'See contracts',
    withNextButton: true,
    withoutHand: true,
    character: {
      png: mainCharPng,
      webp: mainCharWebp,
      config: {
        left: '0',
      },
    },
  },
  23: {
    text: '',
    buttonText: '',
    selector: '#intro-step-23',
  },
  24: {
    text: 'Contracts are the heart of your business. Let’s see what kind of deals we’ve got here',
    buttonText: 'It`s clear',
    character: {
      png: mainCharPng,
      webp: mainCharWebp,
      config: {
        left: '0',
      },
    },
    withNextButton: true,
    withoutHand: true,
  },
  25: {
    text: '',
    buttonText: '',
    selector: '#intro-step-25',
  },
  26: {
    // The native app has no USD earnings
    text: isNativeApp
      ? 'Build and upgrade buildings to level up. The higher the level, the more opportunities you unlock.'
      : 'Build and upgrade buildings to level up. The higher the level, the more opportunities you have to earn USD.',
    buttonText: 'Ok',
    character: {
      png: mainCharPng,
      webp: mainCharWebp,
      config: {
        left: '0',
      },
    },
    withNextButton: true,
    withoutHand: true,
  },
  27: {
    text: isNativeApp
      ? 'Reach Level 2 to unlock Daily Goods.'
      : 'Reach Level 2 to unlock the first USD earning mechanic, Daily Goods.',
    buttonText: 'Claim',
    character: {
      png: mainCharPng,
      webp: mainCharWebp,
      config: {
        left: '0',
      },
    },
    containerStyle: {
      width: '70%',
      transform: 'translate(-60%, -20%)',
    },
    withNextButton: true,
    withoutHand: true,
    defaultPosition: {
      bottom: '100px',
    },
  },
};

const groupedSteps: Record<string, number[]> = {
  welcome: [1],
  wood: [2, 6, 7, 8],
  lumber: [9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
  furniture_factory: [19, 21, 22],
  contracts: [23, 24, 25, 26],
  finishOnboarding: [27],
};

export { groupedSteps, type IntroStepsConfigValue, newIntroSteps };
